class Accordeo {
  private items: NodeListOf<HTMLElement> | null = null;
  onOpen: (item: HTMLElement) => void = () => {};
  onClose: (item: HTMLElement) => void = () => {};

  constructor(items: NodeListOf<HTMLElement>) {
    this.items = items;
  }

  clickItem(clickedItem: HTMLElement) {
    const wasActive = clickedItem.classList.contains('active');

    this.items?.forEach((item) => {
      item.classList.remove('active');
      if(item !== clickedItem) {
        this.onClose(item);
      }
    });

    if(!wasActive) {
      clickedItem.classList.add('active');
      this.onOpen(clickedItem);
    } else {
      this.onClose(clickedItem);
    }
  }

  init() {
    this.items?.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.clickItem(item);
      });
    });
  }
}

export default Accordeo;